export const environment = {
    production: true,
    BaseURL: "https://recruitmentapi.shaligraminfotech.com/api/",
    ApiUrl:"https://recruitmentapi.shaligraminfotech.com/",
};
